module.exports = __webpack_public_path__ + "img/page13-img1.a645ee51.png";